import { useState, useEffect, useCallback } from "react";

import API from "utils/api";

export default function useLightContent(token, type, id = null, query = {}) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);


  const fetchLightContent = useCallback(async () => {
    setLoading(true);
    const { response, data } = await API.fetchLightContent(token, type, id, query);

    if (response.ok) {
      setResult(data);
      setLoading(false);
    } else {
      setResult(null);
      setLoading(false);
    }
  }, [setResult, setLoading]);

  useEffect(() => {
    fetchLightContent();
  }, [type, id, token, setResult, setLoading]);

  return {
    loading,
    result,
    refresh: fetchLightContent,
  };
}
